var _rect, _path, _path2, _path3, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMaster(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.632 28.049a11.337 11.337 0 01-7.33 2.667c-6.242 0-11.302-5-11.302-11.167S15.06 8.383 21.301 8.383c2.797 0 5.357 1.004 7.33 2.667a11.337 11.337 0 017.331-2.667c6.242 0 11.301 5 11.301 11.166 0 6.168-5.06 11.167-11.3 11.167a11.337 11.337 0 01-7.331-2.667z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.632 28.049c2.43-2.049 3.97-5.096 3.97-8.5 0-3.403-1.54-6.45-3.97-8.499a11.337 11.337 0 017.33-2.667c6.241 0 11.301 5 11.301 11.166 0 6.168-5.06 11.167-11.3 11.167a11.337 11.337 0 01-7.331-2.667z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.632 28.049c2.43-2.048 3.97-5.096 3.97-8.5 0-3.402-1.54-6.45-3.97-8.498-2.43 2.048-3.971 5.096-3.971 8.499 0 3.403 1.54 6.45 3.97 8.499z",
    fill: "#FF5E00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}

export default SvgIconMaster;